import styled from 'styled-components'
import { UserAvatar } from 'src/components'

export const Image = styled(UserAvatar)`
  margin-top: ${({ small }) => (small ? '0.625rem' : '0.375rem')};
`

Image.displayName = 'Image'
